// In production (embedded), the websocket lives on the same host. In dev,
// Vite proxies /ws to the Go server on :3000, so we can use the same path.
const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
export const WS_URL = `${wsProtocol}//${window.location.host}/ws`;

// How often the client sends its pose to the server.
export const POSE_SEND_HZ = 20;

// How long we buffer remote racer poses before rendering, to smooth jitter.
export const INTERP_DELAY_MS = 100;

// Default course centerline — used at boot before any race_start arrives.
// The live race centerline arrives on race_start (track.ghostPath) and
// replaces these points in-place via setTrackCenterline so all the
// downstream helpers (Scene terrain, GameLoop surface lookup, etc.) pick
// up the new track without needing to re-import.
const DEFAULT_CENTERLINE = [
  { x: 0,   y: 70, z: 0    },
  { x: -4,  y: 64, z: -60  },
  { x: -22, y: 56, z: -130 },
  { x: -32, y: 48, z: -210 },
  { x: -16, y: 42, z: -280 },
  { x: 8,   y: 36, z: -340 },
  { x: 28,  y: 28, z: -410 },
  { x: 36,  y: 22, z: -490 },
  { x: 22,  y: 16, z: -560 },
  { x: -10, y: 10, z: -620 },
  { x: -28, y: 6,  z: -680 },
  { x: -12, y: 2,  z: -740 },
  { x: 0,   y: 0,  z: -800 },
];

// Exported as a mutable array so any module that imported the reference
// continues to see the live centerline after a track change.
export const TRACK_CENTERLINE = DEFAULT_CENTERLINE.map((p) => ({ ...p }));

// Replace the centerline contents in place. Called when a new track
// arrives via race_start. Followed by Scene.rebuildWorld() so the
// terrain meshes match the new centerline.
export function setTrackCenterline(points) {
  if (!Array.isArray(points) || points.length < 2) return;
  TRACK_CENTERLINE.length = 0;
  for (const p of points) TRACK_CENTERLINE.push({ x: p.x, y: p.y, z: p.z });
}

// Track half-width: how far from the centerline the racing surface stays
// smooth. Walls sit just outside this; mountains rise further out.
export const TRACK_HALF_WIDTH = 8;

// Jump positions along the course, expressed as Z coordinates that get
// matched onto the centerline. Picked so they don't fall on tight corners.
export const JUMP_ZS = [-180, -440, -700];

// Per-lane racer colors. Lane 0 always gets RACER_PALETTES[0] regardless of
// whether the racer is human or AI, so the same outfit shows up in every
// screen for that slot. Keep the array length matched to startLane range.
export const RACER_PALETTES = [
  { jacket: 0x3b82f6, hat: 0xfbbf24, pom: 0xffffff }, // lane 0: blue + yellow hat
  { jacket: 0xef4444, hat: 0x111827, pom: 0xf8fafc }, // lane 1: red + black hat
  { jacket: 0x10b981, hat: 0xfde047, pom: 0x0f172a }, // lane 2: green + gold hat
  { jacket: 0xa855f7, hat: 0xf472b6, pom: 0xfde68a }, // lane 3: purple + pink hat
];

export function paletteForLane(lane) {
  return RACER_PALETTES[lane % RACER_PALETTES.length];
}
